import { render, staticRenderFns } from "./VSTFooter.vue?vue&type=template&id=00d97232&scoped=true"
import script from "./VSTFooter.vue?vue&type=script&lang=js"
export * from "./VSTFooter.vue?vue&type=script&lang=js"
import style0 from "./VSTFooter.vue?vue&type=style&index=0&id=00d97232&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d97232",
  null
  
)

export default component.exports